import { ToastMessageHost } from './ToastMessageHost';
import { ToastMessage } from './ToastMessage';

export const Toast = {
    Host: ToastMessageHost,
    Message: ToastMessage
};
